import dynamic from 'next/dynamic';

import Dialog from 'components/Dialog';

const Drawer = dynamic(() => import('./Drawer'), { ssr: false });
const Modal = dynamic(() => import('./Modal'), { ssr: false });

const GA_EVENT_CATEGORY = 'modal_wishlist';

const WishlistDialog = (props) => (
  <Dialog
    drawer={Drawer}
    gaEventCategory={GA_EVENT_CATEGORY}
    modal={Modal}
    {...props}
  />
);

export default WishlistDialog;
